<template>
  <div class="dropdown-input-container mb-3">
    <label>
      <question-display :question="question"  customClass="header-dropdown"></question-display>
    </label>
    <select
      v-model="inputValue"
      class="form-control form-select"
      @change="updateInput"
    >
      <option value="" disabled selected>Select an option</option>
      <option v-for="option in dropdownOptions" :key="option.value" :value="option.value">
        {{ option.name }}
      </option>
    </select>
    <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import dropdownValues from "@/assets/data/dropdown-values/dropdown.json";
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || '',
      dropdownOptions: []
    };
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit('input', this.inputValue);
    },
    loadDropdownValues() {
      if (this.question["selection-list"]) {
        const key = this.question["selection-list"].value;
        this.dropdownOptions = dropdownValues[key] || [];

        if(this.question['default-value']){
          const defaultConfig = this.question['default-value'];
          const conditionAnswer = surveyService.getAnswer(defaultConfig['question_id']);
          const conditionAnswerStr = String(conditionAnswer || '');
          let defaultVal;
          if (defaultConfig['value'] && defaultConfig['default']) {
            defaultVal = conditionAnswerStr === String(defaultConfig['value'])
              ? defaultConfig['default']
              : conditionAnswer;
          } else {
            defaultVal = conditionAnswer;
          }
          if (defaultVal) {
            surveyService.setAnswer(this.question.id, defaultVal);
          }
        }
      } else {
        this.dropdownOptions = this.question.options || [];
      }
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || '';
      this.loadDropdownValues();
    }
  },
  mounted() {
    this.loadDropdownValues();
  }
};
</script>